import { Sparkle } from "lucide-react";
import { useLang } from "../i18n/LangContext";

const Row = ({ items }) => (
    <div className="flex shrink-0 items-center">
        {items.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-gold sm:text-3xl">
                    {item}
                </span>
                <Sparkle className="h-4 w-4 shrink-0 text-burnt" />
            </span>
        ))}
    </div>
);

const Marquee = () => {
    const { t } = useLang();
    return (
        <div
            data-testid="editorial-marquee"
            className="marquee-mask overflow-hidden border-y border-burnt/15 wine-marquee py-7"
        >
            <div className="flex w-max animate-marquee">
                <Row items={t.marquee} />
                <Row items={t.marquee} />
            </div>
        </div>
    );
};

export default Marquee;
